import { alertRoutine } from '../../redux/Alerts/routines'

import { i18n } from '../../index';
import { connexionUrl } from '../../utils/api';


export const insufficientPermissionsAlertActionCreator = () => (
  alertRoutine.show({
    type: 'dialog',
    maxWidth: 'xs',
    title:  i18n.t('alerts.insufficientPermissions.title'),
    content: i18n.t('alerts.insufficientPermissions.content'),
    action: () => {
      window.location.replace(connexionUrl)
    },
    actionTitle: i18n.t('alerts.insufficientPermissions.actionTitle'),
  })
)
